export default __webpack_public_path__ + "static/media/supply_change_management_transparency_and_accountability.a91991c2.png";